/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { factoryT } from 'factory-t';
import { ReportDto, TurnoversBaseDto } from './reportsClient.typings';

export const reportsDtoFactory = factoryT<ReportDto>({
    cashBoxTaxNumber: '1234567890_11',
    cashRegisterModelName: (ctx) => `Model_000${ctx.index}`,
    companyName: (ctx) => `Company_${ctx.index}`,
    companyTaxNumber: '1234567890_22',
    correction: {
        sum: 15,
        count: 67,
    },
    creditpay: {
        sum: 10,
        count: 20,
    },
    currency: 'AZN',
    moneyBack: {
        sum: 100,
        count: 200,
    },
    operatorName: (ctx) => `OperatorName_${ctx.index}`,
    operatorTaxNumber: '1234567890_33',
    payment: {
        cash: 2000,
        cashless: 50000,
        credit: 300,
        prepayment: 10,
        bonus: 212,
    },
    prepay: {
        sum: 19,
        count: 21,
    },
    regDateAtUtc: '2024-05-01T14:43:53.334',
    rollback: {
        sum: 12,
        count: 22,
    },
    sale: {
        sum: 800,
        count: 275,
    },
    storeAddress: {
        building: 'b. 60 a. 94',
        city: 'Minsk',
        locality: 'Minskiy r-n.',
        postCode: '220013',
        region: 'Belarus',
        street: 'Uborevich',
    },
    storeName: 'SimpleStore',
    storeTaxNumber: '1234567890-44',
    storeType: 'MARKET',
    tradingDay: null,
});

export const reportsByDayDtoFactory = factoryT<ReportDto>({
    cashBoxTaxNumber: '1234567890_00',
    cashRegisterModelName: (ctx) => `Model_000${ctx.index}`,
    companyName: (ctx) => `Company_${ctx.index}`,
    companyTaxNumber: '1234567890_33',
    correction: {
        sum: 15,
        count: 67,
    },
    creditpay: {
        sum: 10,
        count: 20,
    },
    currency: 'AZN',
    moneyBack: {
        sum: 100,
        count: 200,
    },
    operatorName: (ctx) => `OperatorName_${ctx.index}`,
    operatorTaxNumber: '1234567890_44',
    payment: {
        cash: 2000,
        cashless: 50000,
        credit: 300,
        prepayment: 10,
        bonus: 212,
    },
    prepay: {
        sum: 19,
        count: 21,
    },
    regDateAtUtc: '2024-05-01T14:43:53.334',
    rollback: {
        sum: 12,
        count: 22,
    },
    sale: {
        sum: 800,
        count: 275,
    },
    storeAddress: {
        building: 'b. 60 a. 94',
        city: 'Minsk',
        locality: 'Minskiy r-n.',
        postCode: '220013',
        region: 'Belarus',
        street: 'Uborevich',
    },
    storeName: 'SimpleStore',
    storeTaxNumber: '1234567890-55',
    storeType: 'MARKET',
    tradingDay: '2022-03-29',
});

export const turnoversPartialDtoFactory = factoryT<TurnoversBaseDto>({
    cash: 1200,
    cashless: 456,
    credit: 23092,
    prepayment: 3223,
    bonus: 228,
    sales: (ctx) => {
        return {
            count: 23949,
            sum: 324 * ctx.index,
        };
    },
    moneybacks: {
        count: 123,
        sum: 3434,
    },
    rollbacks: {
        count: 323,
        sum: 2030,
    },
    corrections: {
        count: 342,
        sum: 3402340,
    },
});
